import Joi from 'joi';
const productsCarouselBlockSchema = Joi.object({
  type: Joi.string().valid('productsCarouselBlock').required(),
  code: Joi.string().allow('', null),
  title: Joi.string().allow('', null),
  categoryId: Joi.number().allow(0, null).optional(),
  limit: Joi.number().allow(null),
  backgroundColor: Joi.string().allow('', null),
  transparentTiles: Joi.boolean().allow(null),
  products: Joi.array().items(Joi.object().unknown(true)).allow(null).optional()
}).unknown(true);
export default productsCarouselBlockSchema;